import { CloudCommand } from "../types.js";

export const getConversationContact: CloudCommand = {
    action: "CONVERSATION/PARTICIPANT_DATA",
    commandName: "conversations.getConversationContact",
    buildPayload: ({ params }) => {
        const { conversationUrn } = (params ?? {}) as { conversationUrn?: string };
        return { conversationUrn };
    },
};
